import { action } from "satcheljs";

const setupScheduleViewStates = action("SETUP_SCHEDULE_VIEW_STATE", () => ({}));

export default setupScheduleViewStates;
